import React, { ForwardedRef, forwardRef, HTMLAttributes, PropsWithChildren } from 'react';
import { cn } from '@/lib/utils';

interface CardProps extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  children: React.ReactNode;
}

const Card = forwardRef(function Card(props: CardProps, ref?: ForwardedRef<HTMLDivElement>) {
  const { className, children, ...rest } = props;
  return (
    <div
      ref={ref}
      className={cn('bg-bg-card rounded-2xl transition-all border border-border-card', className)}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Card;
